import { IonIcon } from '@ionic/react'
import { checkmarkOutline } from 'ionicons/icons'
import Steps from 'rc-steps'
import 'rc-steps/assets/index.css'
import React from "react"
import { RouteComponentProps, withRouter } from "react-router"

interface Props extends RouteComponentProps<{}> {
  current: number;
}

const EigenheimSteps: React.FC<Props> = (props) => {
  const direction = 'horizontal' // window.innerWidth < 600 ? 'vertical' : 'horizontal';

  const gotoStep = (step: number, path: string) => () => {
    if (step <= props.current) {
      props.history.push({ pathname: path })
    }
  }

  let current = ''

  const title = (text: string, step: number): (string|boolean) => {
    if (window.innerWidth > 600) {
      return text
    }

    if (String(step) === String(props.current)) {
      current = text
    }

    return false
  }

  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      <Steps
        current={props.current}
        direction={direction}
        icons={{
          finish: <IonIcon icon={checkmarkOutline} style={{ marginBottom: -2 }} />,
        }}
      >
        <Steps.Step title={title('Person', 0)} onClick={gotoStep(1, '/person')}/>
        <Steps.Step title={title('Adresse', 1)} onClick={gotoStep(2, '/address')}/>
        <Steps.Step title={title('Gebäude', 2)} onClick={gotoStep(3, '/building')}/>
        <Steps.Step title={title('Zusätze', 3)} onClick={gotoStep(4, '/additional')}/>
        <Steps.Step title={title('Übersicht', 4)} onClick={gotoStep(5, '/summary')}/>
      </Steps>
      {current && <div style={{
        paddingTop: 16,
        paddingBottom: 16,
        borderBottom: '2px solid #EEE',
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#444'
      }}>{current}</div>}
    </div>
  )
}

export default withRouter(EigenheimSteps)
